module.exports = __webpack_public_path__ + "static/averta-bold-f771fbab77c18216b7a64cecacd1c9a8.woff";